"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var Calendar = function Calendar(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    height: "24",
    version: "1.1",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://svgjs.com/svgjs",
    className: "icon icon-no-fill ".concat(className)
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M0.752 3.750 L23.252 3.750 L23.252 23.250 L0.752 23.250 Z",
    fill: "none",
    stroke: fill,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M0.752 9.75L23.252 9.75",
    fill: "none",
    stroke: fill,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M6.752 6L6.752 0.75",
    fill: "none",
    stroke: fill,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.252 6L17.252 0.75",
    fill: "none",
    stroke: fill,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2"
  })));
};
Calendar.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
Calendar.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = Calendar;